"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[3874],{

/***/ 55493:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(78364);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5657);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50556);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68426);
/* harmony import */ var device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47361);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31627);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1428);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(58354);
/* harmony import */ var components_navigation__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(73358);
/* harmony import */ var compositions_ProductPrice_ProductPrice__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(82775);
/* harmony import */ var compositions_ProductImage_ProductImage__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63834);
/* harmony import */ var compositions_buttons_AddToButton_AddToButton__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(68806);
/* harmony import */ var _components_Labels_Labels__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70090);
/* harmony import */ var _components_Notes_Notes__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(41777);
/* harmony import */ var _components_RetailPrice_RetailPrice__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(38769);














const ProductCardDetailed = (props)=>{
    const { className, bgColorClassName = "bg-light-beige", data, buttonProps, position, withoutLink, replaceRatingWithRetailPrice, isEcommerce, withEcommercePrefix = true, withProductPrice = true, withDescription = true, excludeLabels, withoutNotes, withForwardedTradingItemId = false, lazy, onProductClick } = props;
    const { url, image, rebrandImage, brandInfo: { name: brand }, name, description, upchargePrice, rating, notes, fragranceFamilies, rebrandLabels, prices, typeGroup } = data;
    const { isMobile } = (0,device__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    const isWhite = bgColorClassName === "bg-white";
    const { tradingItem, isEcommerceProduct } = (0,helpers__WEBPACK_IMPORTED_MODULE_3__/* .getTradingItem */ .J)({
        product: data,
        isEcommerce,
        isFullSizeBottlePrioritized: isEcommerce
    });
    const isNotesVisible = !withoutNotes && Boolean(notes?.length);
    const isExtraProduct = typeGroup === "PerfumeCase" || typeGroup === "FragranceStorageBox";
    const isHideCasesReviewsEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z.features.hideCasesReviews);
    const isRatingVisible = !isExtraProduct || !isHideCasesReviewsEnabled;
    const addToButtonProps = {
        type: isEcommerceProduct ? "cart" : "queue",
        product: (0,helpers__WEBPACK_IMPORTED_MODULE_3__/* .getAddItemProduct */ .I)({
            product: data,
            tradingItem
        })
    };
    const linkClickHandler = ()=>{
        if (typeof onProductClick === "function") {
            onProductClick({
                position,
                action: "link"
            });
        }
    };
    const productUrl = (()=>{
        let finalUrl = url;
        if (withForwardedTradingItemId) {
            const hasQuery = /\?[^?]+$/.test(finalUrl);
            finalUrl = `${finalUrl}${hasQuery ? "&" : "?"}forwardedTradingItemId=${tradingItem?.id}`;
        }
        if (withEcommercePrefix && isEcommerceProduct && typeGroup !== "GiftSet") {
            finalUrl = `/ecommerce${finalUrl}`;
        }
        return finalUrl;
    })();
    const { volume, unit } = tradingItem?.volume || {};
    const productName = unit && unit !== "pcs" && isEcommerceProduct ? `${name} · ${volume} ${unit}` : name;
    const topContent = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(compositions_ProductImage_ProductImage__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                src: rebrandImage || image,
                bgColor: isWhite ? "white" : "light-beige",
                lazy: lazy
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                className: "mt-8 line-clamp-2",
                message: brand,
                style: "h6",
                color: "gold-50"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                className: "mt-4 line-clamp-2",
                message: productName,
                style: "p3"
            }),
            replaceRatingWithRetailPrice ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_RetailPrice_RetailPrice__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                className: "mt-16",
                price: prices?.retail
            }) : isRatingVisible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                className: "mx-auto mt-16",
                value: rating.avgRate,
                size: 14
            })
        ]
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,classnames__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(className, "relative flex flex-col justify-between px-24 pb-24 pt-16 text-center", bgColorClassName),
        "data-testid": "productCardDetailed",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Labels_Labels__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                labels: rebrandLabels,
                excludeLabels: excludeLabels,
                upchargePrice: upchargePrice,
                isEcommerce: isEcommerceProduct
            }),
            !withoutLink && url ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_navigation__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                to: productUrl,
                onClick: linkClickHandler,
                children: topContent
            }) : topContent,
            Boolean(fragranceFamilies?.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-16",
                children: fragranceFamilies.map((param)=>{
                    let { name } = param;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        className: "mx-4 mt-4",
                        title: name,
                        bgColor: "pink"
                    }, name);
                })
            }),
            isNotesVisible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Notes_Notes__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                // ATTN mirror desktop styles if product cards will be used in row (carousel)
                className: (0,classnames__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("mt-16 flex-none", !isMobile && "min-h-[94rem]"),
                items: notes,
                bgColor: isWhite ? "white" : "light-beige"
            }),
            isEcommerceProduct ? withProductPrice && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(compositions_ProductPrice_ProductPrice__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                className: "mb-8 mt-32 flex flex-auto items-end justify-center",
                data: tradingItem?.prices
            }) : withDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                // Required for safari, includes 16rem of padding
                className: "mt-auto line-clamp-3 max-h-[76rem] pt-16",
                message: description || "",
                messageTag: "div",
                style: "p3",
                html: true
            }),
            Boolean(buttonProps) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(compositions_buttons_AddToButton_AddToButton__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                className: "mt-24 w-full flex-none",
                size: 48,
                ...addToButtonProps,
                ...buttonProps,
                onClick: ()=>{
                    if (typeof onProductClick === "function") {
                        onProductClick({
                            position,
                            action: "Add to cart"
                        });
                    }
                    if (typeof buttonProps.onClick === "function") {
                        buttonProps.onClick();
                    }
                }
            })
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(ProductCardDetailed));


/***/ }),

/***/ 1511:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var components_layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10430);



const ProductCardDetailedSkeleton = (param)=>{
    let { bgColorClassName = "bg-light-beige" } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: `flex flex-col items-center px-24 pt-12 pb-16 ${bgColorClassName}`,
        "data-testid": "productCardDetailedSkeleton",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                pw: 100,
                aspect: 1,
                bgColor: "light-beige"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                className: "mt-12 rounded",
                pw: 50,
                h: 20,
                bgColor: "light-beige"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                className: "mt-12 rounded",
                pw: 80,
                h: 12,
                bgColor: "light-beige"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                className: "mt-24 rounded",
                w: 84,
                h: 14,
                bgColor: "light-beige"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-24 grid grid-flow-col gap-12",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        w: 64,
                        h: 64,
                        circle: true,
                        bgColor: "light-beige"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        w: 64,
                        h: 64,
                        circle: true,
                        bgColor: "light-beige"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        w: 64,
                        h: 64,
                        circle: true,
                        bgColor: "light-beige"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        w: 64,
                        h: 64,
                        circle: true,
                        bgColor: "light-beige"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                className: "mt-36 rounded",
                pw: 100,
                h: 12,
                bgColor: "light-beige"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                className: "mt-8 rounded",
                pw: 100,
                h: 12,
                bgColor: "light-beige"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                className: "mt-8 rounded",
                pw: 80,
                h: 12,
                bgColor: "light-beige"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                className: "mt-24",
                pw: 100,
                h: 48,
                bgColor: "light-beige"
            })
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProductCardDetailedSkeleton);


/***/ }),

/***/ 84313:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ ProductCardDrift_ProductCardDrift)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/components/navigation/Href/Href.tsx
var Href = __webpack_require__(73358);
// EXTERNAL MODULE: ./src/components/inputs/ChipSelect/ChipSelect.tsx
var ChipSelect = __webpack_require__(71130);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/components/dataDisplay/Rating/Rating.tsx + 3 modules
var Rating = __webpack_require__(1428);
// EXTERNAL MODULE: ./src/compositions/ProductPrice/ProductPrice.tsx + 1 modules
var ProductPrice = __webpack_require__(82775);
// EXTERNAL MODULE: ./src/compositions/ProductImage/ProductImage.tsx
var ProductImage = __webpack_require__(63834);
// EXTERNAL MODULE: ./src/compositions/productCards/components/Labels/Labels.tsx + 2 modules
var Labels = __webpack_require__(70090);
// EXTERNAL MODULE: ./src/compositions/buttons/AddToButton/AddToButton.tsx + 3 modules
var AddToButton = __webpack_require__(68806);
// EXTERNAL MODULE: ./local_modules/formular/useField.ts
var useField = __webpack_require__(98917);
// EXTERNAL MODULE: ./local_modules/formular/useFieldState.ts
var useFieldState = __webpack_require__(59283);
// EXTERNAL MODULE: ./src/helpers/modifiers/getAddItemProduct.ts
var getAddItemProduct = __webpack_require__(5657);
// EXTERNAL MODULE: ./src/helpers/modifiers/formatProductLabelsForAnalytics.ts
var formatProductLabelsForAnalytics = __webpack_require__(80921);
// EXTERNAL MODULE: ./src/helpers/modifiers/formatSize.ts
var formatSize = __webpack_require__(86478);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(66226);
;// CONCATENATED MODULE: ./src/compositions/productCards/ProductCardDrift/util/useProductCardDrift.ts




const useProductCardDrift = (param)=>{
    let { data, position, isStarterSet } = param;
    const { brandInfo, tradingItems, url } = data;
    const { driftOption, varietyItems } = (0,react.useMemo)(()=>{
        const option = data.drift?.find((param)=>{
            let { starterSet } = param;
            return isStarterSet === starterSet;
        }) || data.drift?.[0];
        const driftOption = {
            ...option,
            price: option?.price && {
                standardPrice: option.price,
                discountPrice: option.discountPrice
            }
        };
        const varietyItems = data.tradingItems?.items.filter((param)=>{
            let { section } = param;
            return section !== "Subscription";
        }).map((item)=>({
                value: item.id,
                label: item.variety?.name
            }));
        return {
            driftOption,
            varietyItems
        };
    }, [
        data,
        isStarterSet
    ]);
    const isDriftStarterSet = driftOption?.starterSet ?? isStarterSet;
    const isTrackParamsInitializedRef = (0,react.useRef)(false);
    const varietyField = (0,useField/* default */.Z)({
        value: varietyItems?.[0]?.value
    });
    const { value: selectedTradingItemId } = (0,useFieldState/* default */.Z)(varietyField);
    const selectedTradingItem = tradingItems?.items?.find((param)=>{
        let { id } = param;
        return id === selectedTradingItemId;
    });
    const { volume, unit } = selectedTradingItem?.volume || {};
    const name = driftOption?.name || brandInfo.name;
    const image = driftOption?.image || selectedTradingItem?.image || data?.rebrandImage || data?.image;
    const price = driftOption?.price || selectedTradingItem?.prices;
    const description = unit && unit !== "pcs" ? `${data?.name} · ${volume} ${unit}` : data?.name;
    const varietyName = selectedTradingItem?.variety?.name;
    const addToButtonProps = {
        type: "cart",
        product: (0,getAddItemProduct/* getAddItemProduct */.I)({
            product: data,
            tradingItem: selectedTradingItem,
            isDrift: true,
            isStarterSet: isDriftStarterSet
        })
    };
    const productUrl = url && `/ecommerce${url}?driftVariant=${isDriftStarterSet ? "starterSet" : "refill"}&variety=${encodeURIComponent(varietyName)}`;
    const trackParams = (0,react.useMemo)(()=>{
        const { volume, unit } = selectedTradingItem?.volume || {};
        const price = driftOption?.price || selectedTradingItem?.prices;
        return {
            position,
            isStarterSet: isDriftStarterSet,
            productVariantId: selectedTradingItem?.id,
            productVariantName: selectedTradingItem?.variety?.name,
            productId: data.id,
            productPrice: price?.discountPrice?.amount || price?.standardPrice?.amount,
            productLabels: (0,formatProductLabelsForAnalytics/* default */.Z)(data),
            productGender: data.gender,
            productFullName: data.fullName,
            productBrand: data.brandInfo.name,
            productCategory: data.category,
            productVolume: volume ? (0,formatSize/* default */.Z)(volume, unit) : null
        };
    }, [
        isDriftStarterSet,
        selectedTradingItem,
        data,
        driftOption?.price,
        position
    ]);
    (0,react.useEffect)(()=>{
        if (!isTrackParamsInitializedRef.current) {
            isTrackParamsInitializedRef.current = true;
            return;
        }
        (0,analytics/* track */.j)("Product variant select", trackParams);
    }, [
        trackParams
    ]);
    return {
        name,
        image,
        price,
        description,
        varietyField,
        varietyItems,
        addToButtonProps,
        url: productUrl,
        trackParams
    };
};
/* harmony default export */ const util_useProductCardDrift = (useProductCardDrift);

;// CONCATENATED MODULE: ./src/compositions/productCards/ProductCardDrift/messages.ts
/* harmony default export */ const messages = ({
    scentsTitle: {
        en: "Choose your scent"
    },
    refillName: {
        en: "Drift car freshener refill"
    },
    starterSetName: {
        en: "Drift Starter Set"
    }
});

;// CONCATENATED MODULE: ./src/compositions/productCards/ProductCardDrift/ProductCardDrift.tsx












const ProductCardDrift = (props)=>{
    const { className, bgColorClassName = "bg-light-beige", data, isStarterSet = false, buttonProps, position, withoutLink, withDescription = true, excludeLabels, onProductClick, lazy } = props;
    const { rating, upchargePrice, rebrandLabels, description: productDescription } = data;
    const { name, image, price, description, varietyField, varietyItems, addToButtonProps, url, trackParams } = util_useProductCardDrift({
        data,
        position,
        isStarterSet
    });
    const isWhite = bgColorClassName === "bg-white";
    const linkClickHandler = ()=>{
        if (typeof onProductClick === "function") {
            onProductClick({
                action: "link",
                ...trackParams
            });
        }
    };
    const priceRow = /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPrice/* default */.Z, {
        className: "mt-16 flex items-end justify-center",
        data: price
    });
    const topContent = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImage/* default */.Z, {
                src: image,
                bgColor: isWhite ? "white" : "light-beige",
                lazy: lazy
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mt-8 line-clamp-2 max-h-[40rem]",
                message: name,
                style: "h6",
                color: "gold-50"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mt-6 line-clamp-2 max-h-[40rem]",
                message: description,
                style: "p3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                className: "mx-auto mt-16",
                value: rating.avgRate,
                size: 14
            }),
            withDescription && priceRow
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx/* default */.Z)(className, "relative flex flex-col justify-between px-24 pb-24 pt-16 text-center", bgColorClassName),
        "data-testid": "driftProductCard",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Labels/* default */.Z, {
                labels: rebrandLabels,
                excludeLabels: excludeLabels,
                upchargePrice: upchargePrice,
                isEcommerce: true
            }),
            !withoutLink && url ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Href/* default */.Z, {
                to: url,
                onClick: linkClickHandler,
                children: topContent
            }) : topContent,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mt-16",
                message: messages.scentsTitle,
                style: "p5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChipSelect/* default */.Z, {
                className: "mt-12 justify-center",
                itemClassName: "py-6 px-12",
                color: "gold-50",
                labelStyle: "p4",
                field: varietyField,
                options: varietyItems,
                "data-testid": "driftProductCardVarietyOptions"
            }),
            withDescription ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mt-auto line-clamp-3 max-h-[76rem] flex-auto pt-16",
                message: productDescription,
                messageTag: "div",
                style: "p3",
                html: true
            }) : priceRow,
            Boolean(buttonProps) && /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToButton/* default */.Z, {
                className: "mt-24 w-full flex-none",
                size: 48,
                ...addToButtonProps,
                ...buttonProps,
                onClick: ()=>{
                    if (typeof onProductClick === "function") {
                        onProductClick({
                            action: "Add to cart",
                            ...trackParams
                        });
                    }
                    if (typeof buttonProps.onClick === "function") {
                        buttonProps.onClick();
                    }
                }
            })
        ]
    });
};
/* harmony default export */ const ProductCardDrift_ProductCardDrift = (/*#__PURE__*/react.memo(ProductCardDrift));


/***/ }),

/***/ 70260:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ZP: () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   ps: () => (/* binding */ outOfStockButtonProps)
/* harmony export */ });
/* unused harmony export cartButtonProps */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78364);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50556);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5657);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51827);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31627);
/* harmony import */ var components_navigation__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(73358);
/* harmony import */ var components_inputs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21182);
/* harmony import */ var compositions_ProductPrice_ProductPrice__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(82775);
/* harmony import */ var compositions_ProductImage_ProductImage__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(63834);
/* harmony import */ var compositions_buttons_AddToButton_AddToButton__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(68806);
/* harmony import */ var _components_Labels_Labels__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70090);












const EXCLUDED_LABELS = [
    "NEW_ARRIVAL",
    "LIMITED_EDITION"
];
const cartButtonProps = {
    type: "cart",
    title: components_inputs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z.addToCart
};
const outOfStockButtonProps = {
    type: "custom",
    title: components_inputs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z.soldOut,
    disabled: true,
    metadata: {}
};
const ProductCardLimitedDrop = (props)=>{
    const { className, data, link, onLinkClick, withoutButton, withoutLink, buttonProps } = props;
    const { image, prices, limitedEditionInfo, productInfo } = data;
    const { brandInfo: { name: brand }, giftProducts, name, rebrandLabels } = productInfo;
    const isLimitedDropsCheckoutRedirectEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z.abTests.limitedDropsCheckoutRedirect) === "b";
    const addToButtonBaseProps = limitedEditionInfo?.productsRemainingCount > 0 ? cartButtonProps : outOfStockButtonProps;
    const addToButtonProps = {
        ...addToButtonBaseProps,
        withRedirectToCheckout: isLimitedDropsCheckoutRedirectEnabled,
        product: (0,helpers__WEBPACK_IMPORTED_MODULE_5__/* .getAddItemProduct */ .I)({
            product: productInfo,
            tradingItem: data
        })
    };
    const giftDescription = giftProducts?.[0]?.title;
    const isButtonVisible = !withoutButton && Boolean(buttonProps);
    const rootClassName = (0,classnames__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(className, "relative flex flex-col justify-between bg-gray-10 p-12 text-center", !isButtonVisible && "pb-32");
    const content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: rootClassName,
        "data-testid": "productCardLimitedDrop",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Labels_Labels__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                labels: rebrandLabels,
                excludeLabels: EXCLUDED_LABELS,
                isEcommerce: true,
                isSmallCard: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex-auto",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(compositions_ProductImage_ProductImage__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        src: image,
                        bgColor: "gray-10",
                        lazy: false
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                        className: "mt-8 line-clamp-2 break-words",
                        message: brand,
                        style: "h8",
                        color: "gold-50"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                        className: "mt-4 line-clamp-2 break-words",
                        message: name,
                        style: "p4"
                    }),
                    Boolean(giftDescription) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                        className: "line-clamp-2 break-words",
                        message: giftDescription,
                        style: "p5"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(compositions_ProductPrice_ProductPrice__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                className: "mt-12",
                data: prices
            }),
            isButtonVisible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(compositions_buttons_AddToButton_AddToButton__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                className: "mt-20",
                size: 38,
                fullWidth: true,
                ...addToButtonProps,
                ...buttonProps
            })
        ]
    });
    return !withoutLink && link ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_navigation__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
        className: "flex-auto",
        to: link,
        onClick: onLinkClick,
        children: content
    }) : content;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(ProductCardLimitedDrop));


/***/ }),

/***/ 80759:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(78364);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5657);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50556);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68426);
/* harmony import */ var links__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69541);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31627);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1428);
/* harmony import */ var components_navigation__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(73358);
/* harmony import */ var components_inputs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21182);
/* harmony import */ var compositions_ProductPrice_ProductPrice__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(82775);
/* harmony import */ var compositions_ProductImage_ProductImage__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63834);
/* harmony import */ var compositions_buttons_AddToButton_AddToButton__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(68806);
/* harmony import */ var _components_Labels_Labels__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(70090);
/* harmony import */ var _components_RetailPrice_RetailPrice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(38769);














const ProductCardSmall = (props)=>{
    const { className, data, buttonProps, position, withoutLink, replaceRatingWithRetailPrice, isEcommerce, withEcommercePrefix = true, excludeLabels, bgColorClassName = "bg-light-beige", lazy, onProductClick } = props;
    const { url, image, rebrandImage, brandInfo: { name: brand }, name, upchargePrice, rebrandLabels, rating, prices, typeGroup } = data;
    const { tradingItem, isEcommerceProduct, isAcademyCourse } = (0,helpers__WEBPACK_IMPORTED_MODULE_2__/* .getTradingItem */ .J)({
        product: data,
        isEcommerce,
        isFullSizeBottlePrioritized: isEcommerce
    });
    const isExtraProduct = typeGroup === "PerfumeCase" || typeGroup === "FragranceStorageBox";
    const isHideCasesReviewsEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z.features.hideCasesReviews);
    const isRatingVisible = !isExtraProduct || !isHideCasesReviewsEnabled;
    const { volume, unit } = tradingItem?.volume || {};
    let productUrl = withEcommercePrefix && isEcommerceProduct && typeGroup !== "GiftSet" ? `/ecommerce${url}` : url;
    const productName = unit && unit !== "pcs" && isEcommerceProduct ? `${name} · ${volume} ${unit}` : name;
    let addToButtonProps = {
        type: isEcommerceProduct ? "cart" : "queue",
        product: (0,helpers__WEBPACK_IMPORTED_MODULE_2__/* .getAddItemProduct */ .I)({
            product: data,
            tradingItem
        })
    };
    // special case for academy products
    if (isAcademyCourse) {
        productUrl = links__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP.academy.root;
        addToButtonProps = {
            type: "custom",
            title: components_inputs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z.learnMore,
            to: productUrl
        };
    }
    const linkClickHandler = ()=>{
        if (typeof onProductClick === "function") {
            onProductClick({
                position,
                action: "link"
            });
        }
    };
    const isWhite = bgColorClassName === "bg-white";
    const topContent = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(compositions_ProductImage_ProductImage__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                src: rebrandImage || image,
                bgColor: isWhite ? "white" : "light-beige",
                lazy: lazy
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                className: "mt-8 line-clamp-2 break-words",
                message: brand,
                style: "h8",
                color: "gold-50"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                className: "mt-4 line-clamp-2 break-words ",
                message: productName,
                style: "p4"
            }),
            replaceRatingWithRetailPrice ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_RetailPrice_RetailPrice__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                className: "mt-12",
                price: prices?.retail
            }) : isRatingVisible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                className: "mx-auto mt-12",
                value: rating?.avgRate,
                size: 14
            })
        ]
    });
    const rootClassName = (0,classnames__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(className, "relative flex flex-col justify-between p-12 text-center", !buttonProps && "pb-32", bgColorClassName);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: rootClassName,
        "data-testid": "productCardSmall",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Labels_Labels__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                labels: rebrandLabels,
                excludeLabels: excludeLabels,
                upchargePrice: upchargePrice,
                isEcommerce: isEcommerceProduct,
                isSmallCard: true
            }),
            !withoutLink && url ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_navigation__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                className: "flex-auto",
                to: productUrl,
                onClick: linkClickHandler,
                children: topContent
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex-auto",
                children: topContent
            }),
            isEcommerceProduct && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(compositions_ProductPrice_ProductPrice__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                className: "mb-8 mt-16",
                data: tradingItem?.prices
            }),
            Boolean(buttonProps) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(compositions_buttons_AddToButton_AddToButton__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                className: "mt-16",
                size: 38,
                fullWidth: true,
                ...addToButtonProps,
                ...buttonProps,
                onClick: ()=>{
                    if (typeof onProductClick === "function") {
                        onProductClick({
                            position
                        });
                    }
                    if (typeof buttonProps.onClick === "function") {
                        buttonProps.onClick();
                    }
                }
            })
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(ProductCardSmall));


/***/ }),

/***/ 73095:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var components_layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10430);



const ProductCardSmallSkeleton = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col items-center bg-light-beige p-12",
        "data-testid": "productCardSmallSkeleton",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                aspect: 1,
                pw: 100,
                bgColor: "light-beige"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                className: "mt-12 rounded",
                pw: 50,
                h: 12,
                bgColor: "light-beige"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                className: "mt-8 rounded",
                pw: 60,
                h: 12,
                bgColor: "light-beige"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                className: "mt-16 rounded",
                w: 84,
                h: 14,
                bgColor: "light-beige"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                className: "mt-40",
                pw: 100,
                h: 38,
                bgColor: "light-beige"
            })
        ]
    });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProductCardSmallSkeleton);


/***/ }),

/***/ 70090:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ Labels_Labels)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(85183);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/intl/useIntl.ts
var useIntl = __webpack_require__(56376);
// EXTERNAL MODULE: ./src/hooks/useFt.ts
var useFt = __webpack_require__(68426);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(50556);
// EXTERNAL MODULE: ./src/helpers/modifiers/getTestIdFromText.ts
var getTestIdFromText = __webpack_require__(40638);
// EXTERNAL MODULE: ./src/helpers/modifiers/formatPrice.ts
var formatPrice = __webpack_require__(72160);
// EXTERNAL MODULE: ./src/modules/collaborations/useProductCollaborationLabel.ts + 1 modules
var useProductCollaborationLabel = __webpack_require__(52170);
// EXTERNAL MODULE: ./src/components/dataDisplay/Label/Label.tsx + 1 modules
var Label = __webpack_require__(10016);
// EXTERNAL MODULE: ./src/compositions/ProductGraphicLabels/ProductGraphicLabels.tsx
var ProductGraphicLabels = __webpack_require__(80348);
;// CONCATENATED MODULE: ./src/compositions/productCards/components/Labels/util/useExcludeLabels.ts
const useExcludeLabels = function(labels) {
    let ignoreLabels = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    if (!labels || !ignoreLabels.length) {
        return labels;
    }
    return Object.keys(labels).reduce((result, type)=>{
        // have to check because of __typename field
        if (Array.isArray(labels[type])) {
            result[type] = labels[type].filter((label)=>!ignoreLabels.includes(label));
        } else {
            result[type] = labels[type];
        }
        return result;
    }, {});
};
/* harmony default export */ const util_useExcludeLabels = (useExcludeLabels);

;// CONCATENATED MODULE: ./src/compositions/productCards/components/Labels/messages.ts
/* harmony default export */ const messages = ({
    exclusive: {
        en: "Exclusive"
    },
    holiday: {
        en: `{holidayDiscount} off • holiday offer`
    },
    plusFreeGift: {
        en: "+ Free Gift"
    },
    forHer: {
        en: "for her"
    },
    forHim: {
        en: "for him"
    }
});

;// CONCATENATED MODULE: ./src/compositions/productCards/components/Labels/Labels.tsx













const Labels = (props)=>{
    const { labels: rebrandLabels, upchargePrice, isEcommerce, isSmallCard, excludeLabels } = props;
    const intl = (0,useIntl/* default */.Z)();
    const labels = util_useExcludeLabels(rebrandLabels, excludeLabels);
    let collaborationLabel = (0,useProductCollaborationLabel/* default */.Z)({
        labels: labels
    });
    const isGwpSpecificSkuEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.gwpSpecificSku);
    const isHoliday22SaleBadge15Enabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.holiday22SaleBadge15);
    const isHoliday22SaleBadge20Enabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.holiday22SaleBadge20);
    const areExtraItemsExist = Boolean(labels?.extra?.length);
    const areMarketingItemsExist = Boolean(labels?.marketing?.length);
    if (!areExtraItemsExist && !areMarketingItemsExist && !collaborationLabel) {
        return null;
    }
    const isHoliday = (isHoliday22SaleBadge15Enabled || isHoliday22SaleBadge20Enabled) && labels?.extra?.includes("HOLIDAY_SALE");
    const isPlusFreeGift = isGwpSpecificSkuEnabled && labels?.extra?.includes("PLUS_FREE_GIFT");
    const mainLabels = [];
    if (collaborationLabel && !isHoliday) {
        mainLabels.push({
            text: collaborationLabel,
            bgColor: "black",
            textColor: "gold-30"
        });
    }
    if (isHoliday) {
        const holidayDiscount = isHoliday22SaleBadge15Enabled ? "15%" : "20%";
        mainLabels.push({
            text: intl.formatMessage(messages.holiday, {
                holidayDiscount
            }),
            bgColor: "brown-red",
            textColor: "white"
        });
    } else {
        const items = [];
        if (upchargePrice && !isEcommerce) {
            items.push(`+${(0,formatPrice/* default */.Z)(upchargePrice)}`);
        }
        if (labels?.extra?.includes("EXCLUSIVE")) {
            items.push(intl.formatMessage(messages.exclusive));
        }
        if (labels?.extra?.includes("FOR_HER")) {
            items.push(intl.formatMessage(messages.forHer));
        }
        if (labels?.extra?.includes("FOR_HIM")) {
            items.push(intl.formatMessage(messages.forHim));
        }
        if (items.length) {
            mainLabels.push({
                text: items.join(" • "),
                bgColor: "black",
                textColor: "gold-30"
            });
        }
    }
    if (isPlusFreeGift) {
        mainLabels.push({
            text: messages.plusFreeGift,
            bgColor: "gold-70",
            textColor: "white"
        });
    }
    const hasMainLabels = Boolean(mainLabels.length);
    const graphicLabelsClassName = hasMainLabels ? "pt-8" : "pt-16";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "absolute left-0 top-0 z-10 flex flex-col items-start gap-10",
        children: [
            mainLabels.map((param, index)=>{
                let { text, textColor, bgColor } = param;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.ZP, {
                    className: "-ml-6 -mt-6",
                    title: text,
                    bgColor: bgColor,
                    textColor: textColor,
                    withTail: true,
                    "data-testid": (0,getTestIdFromText/* default */.Z)(text, "Label")
                }, index);
            }),
            areMarketingItemsExist && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductGraphicLabels/* default */.Z, {
                className: (0,clsx/* default */.Z)("pl-8", isSmallCard && "origin-top-left scale-75", graphicLabelsClassName),
                items: labels.marketing,
                limit: isSmallCard ? 1 : 2
            })
        ]
    });
};
/* harmony default export */ const Labels_Labels = (/*#__PURE__*/react.memo(Labels));


/***/ }),

/***/ 41777:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78364);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31627);
/* harmony import */ var compositions_ProductImage_ProductImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63834);





const Notes = (props)=>{
    const { className, items, withBlendedImages, justify = "justify-center", bgColor = "light-beige" } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("grid auto-cols-[64rem] grid-flow-col gap-12 text-center", justify, className),
        children: // we should show only 4 notes by design
        items.slice(0, 4).map((param)=>{
            let { image, rebrandImage, name } = param;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(compositions_ProductImage_ProductImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        className: (0,classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("mx-auto w-full", withBlendedImages && !rebrandImage ? "mix-blend-multiply" : null),
                        src: rebrandImage || image,
                        bgColor: bgColor
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                        className: "mt-4",
                        message: name,
                        style: "p5",
                        color: "gray-80"
                    })
                ]
            }, name);
        })
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(Notes));


/***/ }),

/***/ 38769:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ RetailPrice_RetailPrice)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/helpers/modifiers/formatPrice.ts
var formatPrice = __webpack_require__(72160);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
;// CONCATENATED MODULE: ./src/compositions/productCards/components/RetailPrice/messages.ts
/* harmony default export */ const messages = ({
    text: {
        en: "Retail price: {price}"
    }
});

;// CONCATENATED MODULE: ./src/compositions/productCards/components/RetailPrice/RetailPrice.tsx





const RetailPrice = (param)=>{
    let { className, price } = param;
    if (!price || !price.amount && !price.amountCents) {
        return null;
    }
    const formattedPrice = price.amountCents ? (0,formatPrice/* default */.Z)(price.amountCents, {
        isCents: true,
        removeZeroCents: true
    }) : (0,formatPrice/* default */.Z)(price.amount, {
        isCents: false,
        removeZeroCents: true
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
        className: className,
        message: {
            ...messages.text,
            values: {
                price: formattedPrice
            }
        },
        style: "p5",
        "data-testid": "retailPrice"
    });
};
/* harmony default export */ const RetailPrice_RetailPrice = (/*#__PURE__*/react.memo(RetailPrice));


/***/ })

}]);